<template>
  <div>
    <div class="body intro" id="login-main">
      <div v-if="!isLoading">
        <div class="wrap">
          <!-- 상단 로고 부분-->
          <div class="logo-box">
            <span v-if="logo === '' || logo === null || logo === 'undefined'"> </span>
            <img v-else :src="logo" alt="company logo" class="logo-img" />
          </div>

          <!-- 과정 설명 부분-->
          <!-- 상시 신청 -->
          <div v-if="sugang_always_signup_YN === 'Y'" class="desc-box txt-left">
            <p class="title">{{ title }}</p>
            <p class="text">신청내역확인 탭에서 로그인 하시면 신청하신 내역을 확인하실 수 있습니다.</p>
            <span class="apply">
              <span class="apply-btn">신청 기간 : 상시 신청</span>
              <span class="apply-mob"></span>
              <!-- {{ sugangStartDate }} ~ {{ sugangEndDate }} -->
            </span>
            <p class="apply mt-10" v-if="isOnClassTitle">현재 신청 기간이 아닙니다.</p>
            <p class="apply" v-if="isOnClassTitle">신청 기간이 아닌 기간에는 신청내역만 확인하실 수 있습니다.</p>
          </div>
          <!-- 신청 기간 -->
          <div v-else class="desc-box txt-left">
            <p class="title">{{ title }}</p>
            <p class="text">신청내역확인 탭에서 로그인 하시면 신청하신 내역을 확인하실 수 있습니다.</p>
            <span class="apply">
              <span class="apply-btn">신청 기간</span>
              <span class="apply-mob"></span>
              {{ sugangStartDate }} ~ {{ sugangEndDate }}
            </span>
            <p class="apply mt-10" v-if="isOnClassTitle">현재 신청 기간이 아닙니다.</p>
            <p class="apply" v-if="isOnClassTitle">신청 기간이 아닌 기간에는 신청내역만 확인하실 수 있습니다.</p>
          </div>
          <!-- 다운로드 탭 -->
          <div class="download" v-if="this.is_download1 == 'Y' || this.is_download2 == 'Y' || this.is_download3 == 'Y'">
            <div class="tab" v-if="this.is_download1 == 'Y'" :class="download_cnt == 1 ? 'tab-cnt1' : download_cnt == 2 ? 'tab-cnt2' : 'tab-cnt3'">
              <a class="circle circle-color1 pointer" @click="downloadFile(download_file1_url)" target="new">
                <img src="../assets/img/download-arrow.svg" />
              </a>
              <div class="text">
                {{ download_file1_name }}
              </div>
            </div>
            <p class="bar" v-if="this.is_download2 == 'Y'"></p>
            <div class="tab" v-if="this.is_download2 == 'Y'" :class="download_cnt == 1 ? 'tab-cnt1' : download_cnt == 2 ? 'tab-cnt2' : 'tab-cnt3'">
              <a @click="downloadFile(download_file2_url)" target="_blank" class="circle circle-color2 pointer">
                <img src="../assets/img/download-arrow.svg" />
              </a>
              <div class="text">
                {{ download_file2_name }}
              </div>
            </div>
            <p class="bar" v-if="this.is_download3 == 'Y'"></p>
            <div class="tab" v-if="this.is_download3 == 'Y'" :class="download_cnt == 1 ? 'tab-cnt1' : download_cnt == 2 ? 'tab-cnt2' : 'tab-cnt3'">
              <a @click="downloadFile(download_file3_url)" target="_blank" class="circle circle-color3 pointer">
                <img src="../assets/img/download-arrow.svg" />
              </a>
              <div class="text">
                {{ download_file3_name }}
              </div>
            </div>
          </div>
          <div class="no-download" v-if="this.is_download1 !== 'Y' && this.is_download2 !== 'Y' && this.is_download3 !== 'Y'"></div>

          <!-- 다운로드 탭 모바일용 360px-->
          <div class="download-mob" v-if="this.is_download1 == 'Y'">
            <div class="tab" v-if="this.is_download1 == 'Y'">
              <a @click="downloadFile(download_file1_url)" target="_blank" class="circle circle-color1 pointer">
                <img src="../assets/img/download-arrow.svg" />
              </a>
              <div class="text">
                {{ download_file1_name }}
              </div>
            </div>
          </div>
          <div class="download-mob" v-if="this.is_download2 == 'Y'">
            <div class="tab" v-if="this.is_download2 == 'Y'">
              <a @click="downloadFile(download_file2_url)" target="_blank" class="circle circle-color2 pointer">
                <img src="../assets/img/download-arrow.svg" />
              </a>
              <div class="text">
                {{ download_file2_name }}
              </div>
            </div>
          </div>
          <div class="download-mob" v-if="this.is_download3 == 'Y'">
            <div class="tab" v-if="this.is_download3 == 'Y'">
              <a @click="downloadFile(download_file3_url)" target="_blank" class="circle circle-color3 pointer">
                <img src="../assets/img/download-arrow.svg" />
              </a>
              <div class="text">
                {{ download_file3_name }}
              </div>
            </div>
          </div>

          <!-- 이미지 아래 박스-->
          <div class="box">
            <div class="login-box" :class="tabType == 'login' ? 'login-margin' : ''"  >
              <ul>
                <li class="pointer tablinks" @click="selectTab('access')" :class="setColor('access')">신청하기</li>
                <li class="pointer tablinks" @click="selectTab('login')" :class="setColor('login')">신청내역확인</li>
              </ul>
              <!-- 신청하기 탭 -->
              <div v-if="tabType === 'access'" class="tab-con" id="apply-tab" :class="setTabType()" >
                <div v-if="isOnClass" class="login-input">
                  <label for="" class="dp-block">
                    <!-- 관리자단에서 회사 메일 주소를 입력했을 경우 -->
                    <span v-if="useUrl" class="company-mail">
                      <input type="text" v-if="item_message != ''" v-model="email" :placeholder="item_message" />
                      <input v-else type="text" v-model="email" placeholder="아이디를 입력해주세요." />
                      <span class="mail-txt">{{ item_email.replace("E-mail", "") }}</span>
                    </span>
                    <span v-else class="company-mail"> <input type="text" v-model="email" placeholder="E-mail을 입력해주세요." class="w-100per" /><span class="ml-05"></span> </span>
                  </label>

                  <!-- 입력오류 시 노출 -->
                  <p></p>
                  <label for="" class="dp-block">
                    <span class="company-pass">
                      <input v-if="accessCodePass == 'N'" type="password" v-model="accessCode" @keyup.enter="login('access')" placeholder="Access Code를 입력해 주세요." class="w-100per mb-10" />
                    </span>
                  </label>
                  <label   for="" class="dp-block" v-if="isAddPassword">
                    <span class="company-mail" >
                     <input type="password" v-model="login_password" placeholder="비밀번호를 입력해 주세요." class="w-100per mb-10" @keyup.enter="login('access')" />
                    </span>
                  </label>


                  <!-- 입력오류 시 노출 -->
                  <p class="txt-red" v-if="!isValidAccess">Access Code가 일치하지 않습니다. 다시 입력해주세요.</p>

                  <div class="confirm" @click="login('access')">
                    <div class="loader" v-if="submitLoadingBar"></div>
                    <span v-else>확인</span>
                  </div>


                  <p v-if="lock === 'unlock'" class="txt-blue mt-10 underline txt-center pointer" @click="openModal('findPW')">비밀번호를 잊으셨나요? 비밀번호 찾기</p>
                  <findpw-modal v-if="isFindPWModalOpened" @close="closeModal"></findpw-modal>
                  <p v-if="lock !== 'unlock'" class="txt-blue mt-10 underline txt-center pointer" @click="openModal('unlock')">비밀번호를 잊으셨나요? 비밀번호 찾기</p>
                  <lock-modal v-if="isLockModalOpened" @close="closeModal"></lock-modal>
                </div>
                <!-- 수강신청이 지났을 경우/시작되기 전 경우 문구 -->
                <div v-else class="login-txt">
                  <h3 class="bold">신청 기간이 아닙니다.</h3>
                  <!-- 수강신청이 지났을 경우 -->
                  <p v-if="!isExpect">
                    수강신청을 하셨을 경우 신청내역확인 탭에서 <br />
                    신청내역을 확인하실 수 있습니다.
                  </p>
                  <!-- 수강신청이 시작되기 전 일 경우 -->
                  <p else>곧 수강신청이 진행될 예정입니다.</p>
                </div>
              </div>
              <!-- 신청내역확인 탭 -->
              <div v-else class="tab-con" id="apply-check-tab" :class="setTabType()">
                <div class="login-input">
                  <label for="" class="dp-block">
                    <span v-if="useUrl" class="company-mail">
                      <input type="text" v-if="item_message != ''" v-model="email" :placeholder="item_message" />
                      <input v-else type="text" v-model="email" placeholder="아이디를 입력해주세요." />
                      <span class="mail-txt">{{ item_email.replace("E-mail", "") }}</span>
                    </span>
                    <span v-else class="company-mail" style="border-radius: 15px">
                      <input type="text" v-model="email" placeholder="E-mail을 입력해주세요." class="w-100per" /><span class="ml-05"></span>
                    </span>
                  </label>
                  <p />
                  <label for="" class="dp-block">
                    <span class="company-pass">
                      <input type="password" v-model="password" placeholder="비밀번호를 입력해 주세요." class="w-100per mb-10" @keyup.enter="login('login')" />
                    </span>
                  </label>
                  <!-- 입력오류 시 노출 -->
                  <div class="err-msg">
                    <p v-if="loginFailCount !== 0">
                      로그인 <span style="color: red">{{ loginFailCount }}</span
                      >회 실패하였습니다. <br />
                      로그인 연속 <span style="color: red">5</span>회 실패 시 로그인이 <span style="color: red">차단</span>됩니다.
                    </p>
                    <p class="txt-red" v-if="!isValidAuth">E-mail 또는 비밀번호가 일치하지 않습니다.</p>
                    <p v-else></p>
                  </div>

                  <div class="confirm-login" @click="login('login')">
                    <span>확인</span>
                  </div>

                  <p v-if="lock === 'unlock'" class="txt-blue mt-10 underline txt-center pointer" @click="openModal('findPW')">비밀번호를 잊으셨나요? 비밀번호 찾기</p>
                  <findpw-modal v-if="isFindPWModalOpened" @close="closeModal"></findpw-modal>
                  <p v-if="lock !== 'unlock'" class="txt-blue mt-10 underline txt-center pointer" @click="openModal('unlock')">비밀번호를 잊으셨나요? 비밀번호 찾기</p>
                  <lock-modal v-if="isLockModalOpened" @close="closeModal"></lock-modal>
                </div>
                <!--
                <div class="contact">
                  <b v-if="accessCodePass == 'N'">Access Code & 문의</b>
                  <button class="float-right" @click="openModal('qna')">
                    1:1 문의하기
                  </button>
                </div>
                <div class="manager-wrap">
                  <p v-if="accessCodePass == 'N'">
                    Access Code는 수강 신청 안내문 mail 혹은 공지에서 확인이
                    가능하며, 확인이 어려울 시 아래의 매니저에게 문의 주시길
                    바랍니다.
                  </p>
                  <p v-for="(item, index) of qaAdminInfo" :key="index">
                    {{ item }}
                  </p>
                </div>
                -->
              </div>
            </div>

            <!-- notice  -->
            <div class="notice" :class="tabType == 'login' ? 'login-margin' : ''">
              <!--swiper -->
              <div class="swiper" v-if="is_swipe == 'Y'">
                <template>
                  <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-if="swipe1_url">
                      <p class="swiper-slide-text">01/03</p>
                      <img class="swiper-slide" :src="swipe1_url" />
                    </swiper-slide>
                    <swiper-slide v-if="swipe2_url">
                      <p class="swiper-slide-text">02/03</p>
                      <img class="swiper-slide" :src="swipe2_url" />
                    </swiper-slide>
                    <swiper-slide v-if="swipe3_url">
                      <p class="swiper-slide-text">03/03</p>
                      <img class="swiper-slide" :src="swipe3_url" />
                    </swiper-slide>

                    <!-- pagination -->
                    <!-- 커스터마이징 swiper-pagination-custom
                    <div class="swiper-pagination swiper-pagination-custom" slot="pagination"></div>
-->
                    <!-- navigation -->
                    <!-- 커스터마이징 swiper-btn-prev, swiper-btn-next -->
                    <div class="swiper-button-prev swiper-btn-prev" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-btn-next" slot="button-next"></div>
                  </swiper>
                </template>
              </div>
              <!--swiper end -->

              <div :class="is_swipe == 'Y' ? 'notice-div' : 'only-notice-div'">
                <p class="notice-title">Notice</p>
                <div class="notice-line"></div>
                <p class="preline notice-content" v-html="infoMessage"></p>
              </div>
              <!--
              <p class="notice-title">Notice</p>
              <div class="notice-box">
                <p class="preline notice-content" v-html="infoMessage"></p>
              </div>
              -->
            </div>
          </div>

          <!--footer-->
        </div>
        <div />
        <div />
        <div />
      </div>
      <div v-else>
        <loading></loading>
      </div>

      <!-- footer -->
      <div class="footer" :class="tabType == 'login' ? 'footer-margin' : ''">
        <div class="div1">
          <div class="content" style="display: block">
            <span class="float-left">
              <div class="float-left">
                <img src="../assets/img/qna_logo.png" />
                <span class="qna-text"> 문의하기 </span>
                <span class="qna-bar"> | </span>
              </div>
              <div class="float-left qna-text2">
                <span v-for="(item, index) of qaAdminInfo" :key="index" v-if="index < 5">담당 매니저: {{ item }}<br /> </span>
              </div>
            </span>
          </div>
        </div>

        <div class="div2">
          <div class="content">
            <span class="float-left"> Copyright (c)CARROT Global Inc. All Rights reserved. </span>
          </div>
        </div>
      </div>
    </div>

    <qna-modal v-if="isQnaModalOpened" @close="closeModal()"></qna-modal>
    <!-- <waitModal></waitModal> -->
  </div>
</template>

<script>
import { EmptyCheck, EmailFormatCheck } from "@/utils/validation.js";
import FindpwModal from "@/components/login/findPWModal.vue";
import LockModal from "@/components/login/LockModal.vue";
import QnaModal from "@/components/qnaModal.vue";
import Loading from "@/components/loading.vue";
import FileSaver from "file-saver";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    FindpwModal,
    QnaModal,
    LockModal,
    Loading: Loading,
    Swiper,
    SwiperSlide,
    // waitModal
  },
  data: () => ({
    email: "",
    accessCode: "",
    password: "",
    login_password: "",
    tabType: "access",

    isFindPWModalOpened: false, // 비밀번호 찾기 팝업 on/off
    isQnaModalOpened: false, // 1:1 문의 팝업 on/off
    isLockModalOpened: false, // 계정잠금 팝업 on/off
    isOnClass: true, // 수강신청 가능 기간인지 여부
    isExpect: true, // 곧 수강신청 예정이 있는지 여부
    isValidAccess: true, // Access Code가 유효한지 여부
    isAddPassword: false, // Access Code가 유효한지 여부
    isValidAuth: true, //  이메일, 비밀번호가 유효한지 여부
    isLoading: false, // 페이지 로딩 여부
    isOnClassTitle: false, // 수강신청 여부 타이틀에 노출여부

    infoMessage: "", // Notice 내용
    item_email: "", // 관리자단- 신청자정보에서 이메일 등록한 주소값
    item_message: "", //관리자단 - 신청자정보에서 이메일 placeholder값
    logo: "", // 회사 로고 url
    main: "", // 메인 배경 url
    pageIdx: "", // 페이지 idx (itm_main_page_idx와 같음)
    pointColor: "Blue", // 메뉴와 버튼 색깔
    qaAdmin: "", // hq 매니저
    qaAdminInfo: "", // hq 매니저 정보
    sugang_always_signup_YN: "",
    sugangStartDate: "2020-01-01 00:00", // 수강신청 시작 날짜
    sugangEndDate: "2020-12-30 00:00", // 수강신청 종료 날짜
    title: "", // 프로그램명 타이틀
    accessCodePass: "", //엑세스 코드 패스 여부

    download_file1_name: "",
    download_file2_name: "",
    download_file3_name: "",
    download_file1_url: "",
    download_file2_url: "",
    download_file3_url: "",
    is_swipe: "",
    swipe1_url: "",
    swipe2_url: "",
    swipe3_url: "",
    is_download1: "",
    is_download2: "",
    is_download3: "",
    download_cnt: 0,

    useUrl: true, // 아이디 입력란에 주소사용할것인지
    onlySearch: false,
    lock: "unlock",
    loginFailCount: 0,

    submitLoadingBar: false,

    errorCode: "",
    swiperOptions: {
      loop: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  }),

  watch: {
    tabType() {
      this.reset();
    },
  },

  mounted() {
    // 1시간 내로 한번씩 캐시 초기화를 시켜준다.
    if (localStorage.getItem("refreshDate")) {
      var oldTime = Number(localStorage.getItem("refreshDate"));
      var newTime = new Date().getTime();
      if (newTime - oldTime > 3600000) {
        localStorage.setItem("refreshDate", new Date().getTime());
        location.reload(true);
      }
    } else {
      localStorage.setItem("refreshDate", new Date().getTime());
      location.reload(true);
    }

    sessionStorage.removeItem("onlySearch");
    this.axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    //this.axios.defaults.headers.common["Content-Disposition"] = "attachment";

    this.axios.defaults.headers.common["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,OPTIONS";
    this.axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Content-Type, Authorization, Content-Length, X-Requested-With";

    var companyCode = "ehddkeo";

    if (sessionStorage.getItem("companyCode")) {
      companyCode = sessionStorage.getItem("companyCode");
    }

    this.isLoading = true;

    let params = new URLSearchParams();
    params.append("companyCode", companyCode);
    this.axios.get(this.axios.root + this.axios.port + `/user/main/${companyCode}`, params).then((res) => {
      this.isLoading = false;
      this.errorCode = res.data.err;
      if (res.data.err === 0) {
        for (var item of Object.keys(res.data)) {
          if (typeof this[item] !== "undefined") {
            this[item] = res.data[item];
            // 배경 이미지 변경
            if (item === "main") {
              document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
              document.getElementById("login-main").style["background-size"] = "cover";
            }

            if (item === "pageIdx") {
              sessionStorage.setItem("pageIdx", res.data[item]);
            }

            if (item === "download_file1_name") this.download_file1_name = res.data[item];
            if (item === "download_file2_name") this.download_file2_name = res.data[item];
            if (item === "download_file3_name") this.download_file3_name = res.data[item];
            if (item === "is_swipe") this.is_swipe = res.data[item];
            if (item === "swipe1_url") this.swipe1_url = res.data[item];
            if (item === "swipe2_url") this.swipe2_url = res.data[item];
            if (item === "swipe3_url") this.swipe3_url = res.data[item];
            if (item === "is_download1") this.is_download1 = res.data[item];
            if (item === "is_download2") this.is_download2 = res.data[item];
            if (item === "is_download3") this.is_download3 = res.data[item];
          }
        }
        if (this.qaAdminInfo !== "") {
          this.qaAdminInfo = this.qaAdminInfo.split("^");
        }

        if (this.item_email.replace("E-mail@", "").trim() === "") {
          this.useUrl = false;
        }

        sessionStorage.setItem("pointColor", res.data.pointColor);

        document.title = this.title;

        this.download_cnt = 0;
        if (this.is_download1 == "Y") {
          this.download_cnt++;
        }
        if (this.is_download2 == "Y") {
          this.download_cnt++;
        }
        if (this.is_download3 == "Y") {
          this.download_cnt++;
        }
      } else if (res.data.err === 105) {
        this.onlySearch = true;
        this.tabType = "login";
        sessionStorage.setItem("onlySearch", "Y");
        alert("신청 기간이 아닙니다. \n신청이 종료된 후 1년이 지나지 않았을 시에는\n신청내역 확인에서 신청한 내역들을 확인할 수 있습니다.");
      } else if (res.data.err === 900) {
        if (sessionStorage.getItem("isAdmin")) {
          for (var item of Object.keys(res.data)) {
            if (typeof this[item] !== "undefined") {
              this[item] = res.data[item];
              // 배경 이미지 변경
              if (item === "main") {
                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                document.getElementById("login-main").style["background-size"] = "cover";
              }

              if (item === "pageIdx") {
                sessionStorage.setItem("pageIdx", res.data[item]);
              }
            }
          }
          if (this.qaAdminInfo !== "") {
            this.qaAdminInfo = this.qaAdminInfo.split("^");
          }

          if (this.item_email.replace("E-mail@", "").trim() === "") {
            this.useUrl = false;
          }

          sessionStorage.setItem("pointColor", res.data.pointColor);

          document.title = this.title;
        } else {
          this.onlySearch = true;
          this.tabType = "login";
          for (var item of Object.keys(res.data)) {
            if (typeof this[item] !== "undefined") {
              this[item] = res.data[item];
              // 배경 이미지 변경
              if (item === "main") {
                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                document.getElementById("login-main").style["background-size"] = "cover";
              }

              if (item === "pageIdx") {
                sessionStorage.setItem("pageIdx", res.data[item]);
              }
            }
          }
          if (this.qaAdminInfo !== "") {
            this.qaAdminInfo = this.qaAdminInfo.split("^");
          }

          if (this.item_email.replace("E-mail@", "").trim() === "") {
            this.useUrl = false;
          }

          sessionStorage.setItem("pointColor", res.data.pointColor);

          // 웹 브라우저 탭 제목 변경
          document.title = this.title;
          alert("신청 기간이 아닙니다.");
        }
      } else if (res.data.err === 901) {
        if (sessionStorage.getItem("isAdmin")) {
          for (var item of Object.keys(res.data)) {
            if (typeof this[item] !== "undefined") {
              this[item] = res.data[item];
              // 배경 이미지 변경
              if (item === "main") {
                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                document.getElementById("login-main").style["background-size"] = "cover";
              }

              if (item === "pageIdx") {
                sessionStorage.setItem("pageIdx", res.data[item]);
              }
            }
          }
          if (this.qaAdminInfo !== "") {
            this.qaAdminInfo = this.qaAdminInfo.split("^");
          }

          if (this.item_email.replace("E-mail@", "").trim() === "") {
            this.useUrl = false;
          }

          sessionStorage.setItem("pointColor", res.data.pointColor);

          document.title = this.title;
        } else {
          this.onlySearch = true;
          this.tabType = "login";
          sessionStorage.setItem("onlySearch", "Y");
          for (var item of Object.keys(res.data)) {
            if (typeof this[item] !== "undefined") {
              // 변수로 지정한 값만 데이터 들어가게 지정
              this[item] = res.data[item];
              // 배경 이미지 변경
              if (item === "main") {
                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                document.getElementById("login-main").style["background-size"] = "cover";
              }

              if (item === "pageIdx") {
                sessionStorage.setItem("pageIdx", res.data[item]);
              }
            }
          }
          if (this.qaAdminInfo !== "") {
            this.qaAdminInfo = this.qaAdminInfo.split("^");
          }

          if (this.item_email.replace("E-mail@", "").trim() === "") {
            this.useUrl = false;
          }

          sessionStorage.setItem("pointColor", res.data.pointColor);

          // 웹 브라우저 탭 제목 변경
          document.title = this.title;
          alert("신청 기간이 아닌 기간에는 신청내역만 확인하실 수 있습니다.");
          this.isOnClassTitle = true;
        }
      } else if (res.data.err === 902) {
        if (sessionStorage.getItem("isAdmin")) {
          for (var item of Object.keys(res.data)) {
            if (typeof this[item] !== "undefined") {
              this[item] = res.data[item];
              // 배경 이미지 변경
              if (item === "main") {
                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                document.getElementById("login-main").style["background-size"] = "cover";
              }

              if (item === "pageIdx") {
                sessionStorage.setItem("pageIdx", res.data[item]);
              }
            }
          }
          if (this.qaAdminInfo !== "") {
            this.qaAdminInfo = this.qaAdminInfo.split("^");
          }

          if (this.item_email.replace("E-mail@", "").trim() === "") {
            this.useUrl = false;
          }

          sessionStorage.setItem("pointColor", res.data.pointColor);

          document.title = this.title;
          // alert('신청 기간이 아닙니다. \n신청이 종료된 후 1년이 지나지 않았을 시에는\n신청내역 확인에서 신청한 내역들을 확인할 수 있습니다.')
        } else {
          for (var item of Object.keys(res.data)) {
            if (typeof this[item] !== "undefined") {
              this[item] = res.data[item];
              // 배경 이미지 변경
              if (item === "main") {
                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                document.getElementById("login-main").style["background-size"] = "cover";
              }

              if (item === "pageIdx") {
                sessionStorage.setItem("pageIdx", res.data[item]);
              }
            }
          }
          if (this.qaAdminInfo !== "") {
            this.qaAdminInfo = this.qaAdminInfo.split("^");
          }

          if (this.item_email.replace("E-mail@", "").trim() === "") {
            this.useUrl = false;
          }

          sessionStorage.setItem("pointColor", res.data.pointColor);
          this.onlySearch = true;
          this.tabType = "login";
          this.isOnClassTitle = true;
          sessionStorage.setItem("onlySearch", "Y");
          alert("신청 기간이 아닙니다.");
        }
      }
    });

    //pageMode 값에 따라 신청하기 탭을 보여줄 것인지, 내역 탭을 보여줄 것인지 비교
    if (sessionStorage.getItem("loginPageMode") && sessionStorage.getItem("loginPageMode") == "history") {
      this.selectTab('login');
      sessionStorage.setItem("loginPageMode", "");
    }
  },

  methods: {
    downloadFile(url) {
      //네이버 클라우드 CORS 오류로 storage/download-object 사용
      const url_arr = url.split("/");
      const fileName = url_arr[url_arr.length - 1];
      const folderName = url_arr[url_arr.length - 2];
      const download_url = this.axios.root + this.axios.port + "/storage/download-object?fileName=" + fileName + "&folderName=" + folderName;
      const link = document.createElement("a");
      link.setAttribute("download", fileName);
      link.href = download_url; //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    // 입력한 이메일로 비밀번호 재설정 메일 발송
    sendEmail() {
      var pageIdx = this.pageIdx;
      var params = {
        code: "password_email",
        id: this.email,
        pageIdx: pageIdx,
      };

      this.axios
        .get(this.axios.root + this.axios.port + `/user/password-email/${pageIdx}`, {
          params: params,
        })
        .then((res) => {
          this.isSend = true;
          // console.log('res', res)
          sessionStorage.setItem("fixPWEmail", this.email);
          localStorage.setItem("authEmail", this.email);
          alert("발송 되었습니다.");
        })
        .catch((err) => {
          alert("수강신청 내역이 없는 E-mail입니다.");
          // console.log(err)
          // alert(err)
        });
    },

    // 탭 선택 토글
    selectTab(type) {
      if (this.onlySearch) {
        if (this.errorCode !== 0) {
          if (this.errorCode === 105) {
            alert("신청 기간이 아닙니다. \n신청이 종료된 후 1년이 지나지 않았을 시에는\n신청내역 확인에서 신청한 내역들을 확인할 수 있습니다.");
          } else if (this.errorCode === 901) {
            alert("신청 기간이 아닌 기간에는 신청내역만 확인하실 수 있습니다.");
          } else {
            alert("신청 기간이 아닙니다.");
          }
        }
        return false;
      } else {
        this.tabType = type;
      }
    },

    // 관리자에서 지정한 컬러로 css-class적용
    setColor(type) {
      if (type === this.tabType) {
        return "active";
      }
      /*
      if (type === this.tabType) {
        if (this.pointColor === "Blue") {
          return "on-blue active";
        } else if (this.pointColor === "Red") {
          return "on-red active";
        } else if (this.pointColor === "Green") {
          return "on-green active";
        } else if (this.pointColor === "Grey") {
          return "active";
        }
      } else if (type === this.tabType) {
        if (this.pointColor === "Blue") {
          return "on-blue active";
        } else if (this.pointColor === "Red") {
          return "on-red active";
        } else if (this.pointColor === "Green") {
          return "on-green active";
        } else if (this.pointColor === "Grey") {
          return "active";
        }
      }
      */
    },
    setTabType() {
      return this.tabType;
    },

    // 탭 변경시 입력값 초기화
    reset() {
      this.email = "";
      this.accessCode = "";
      this.password = "";
      this.login_password="";
      this.isAddPassword="";
    },

    // 로그인: Access Code로그인과 신청내역확인 로그인 2종류
    login(type) {
      if (this.submitLoadingBar) {
        alert("확인중입니다");
      } else {
        if (type === "access") {
          // 이메일 유효성 검사
          if (this.useUrl) {
            if (!EmailFormatCheck(this.email + this.item_email.replace("E-mail", ""))) {
              return false;
            }
          } else {
            if (!EmailFormatCheck(this.email)) {
              return false;
            }
          }

          var params = new URLSearchParams();

          // Access Code 유효성 검사
          if (this.accessCodePass == "N") {
            if (!EmptyCheck(this.accessCode, "Access Code를")) {
              return false;
            }
            params.append("accessCode", this.accessCode);
          }

          sessionStorage.setItem("pageIdx", this.pageIdx);

          params.append("accessCodePass", this.accessCodePass);
          params.append("pageIdx", this.pageIdx);

          /* var params = { 웹취약점
                      accessCode: this.accessCode,
                      id: this.email + this.item_email.replace('E-mail@', ''),
                      pageIdx: this.pageIdx
                  } */

          // 로그인시 관리자에서 도메인을 입력한 경우 파라마티값 추가
          if (this.useUrl) {
            //params['id'] = this.email + this.item_email.replace('E-mail', '')
            params.append("id", this.email + this.item_email.replace("E-mail", ""));
          } else {
            params.append("id", this.email + this.item_email.replace("E-mail@", ""));
          }

          params.append("login_password", this.login_password);

          //this.axios.post(this.axios.root + this.axios.port + `/login/${this.pageIdx}`, {
          //        params: params
          //}).then(res => { 웹취약점
          this.submitLoadingBar = true;
          this.axios
            .post(this.axios.root + this.axios.port + "/login/page", params)
            .then((res) => {
              console.log("res", res);
              if (res.data.err === 0) {
                this.isValidAccess = true;
                localStorage.setItem("accessToken", res.data.accessToken);
                // localStorage.setItem('adminId', this.id)
                localStorage.setItem("userId", this.email);
                this.axios.defaults.headers.common["accessToken"] = res.data.accessToken;
                sessionStorage.setItem("mainIdx", res.data.main.idx);
                sessionStorage.setItem("pageIdx", res.data.main.idx_itm_sugang_page_main);
                sessionStorage.setItem("logo", this.logo);
                sessionStorage.setItem("mainTitle", this.title);
                sessionStorage.setItem("qaAdminInfo", this.qaAdminInfo);
                sessionStorage.setItem("cancle_YN", res.data.main.cancle_YN);
                sessionStorage.setItem("partial_pay", res.data.main.partial_pay);
                sessionStorage.setItem("program_dup_YN", res.data.main.program_dup_YN);
                this.fetchProcessData();
              } else if (res.data.err === 101) {
                this.isAddPassword = true;
                this.$nextTick(() => {
                  alert("기존에 수강신청한 이력이 있습니다. 비밀번호를 입력해 주세요. 비밀번호를 잊어버린 경우 \"비밀번호 찾기\"를 이용해주세요.\n"  );
                });
                return false;
              }
              else if (res.data.err === 105) {
                alert("정확한 Access Code를 입력해 주세요.");
                this.isValidAccess = false;
                return false;
              }
              else if (res.data.err === 140) {
                alert("입력한 정보가 맞지 않습니다.");
                this.loginFailCount = res.data.loginFailCount;
                this.isValidAuth = false;
                return false;
              } else if (res.data.err === 666) {
                alert("5회 로그인 실패로 해당 계정은 잠겼습니다." + "\n" + "신청내역확인의  [비밀번호를 잊으셨나요? 비밀번호 찾기]를 이용해주세요");
                this.lock = "lock";
                this.loginFailCount = res.data.loginFailCount;
              }
              else {
                alert(res.data.result);
                this.isValidAccess = false;
                return false;
              }
            })
            .catch((error) => {
              this.submitLoadingBar = false;
            })
            .finally(() => {
              this.submitLoadingBar = false;
            });
        } else {
          // 이메일 포맷 유효성검사
          if (this.useUrl) {
            if (!EmailFormatCheck(this.email + this.item_email.replace("E-mail", ""))) {
              return false;
            }
          } else {
            if (!EmailFormatCheck(this.email)) {
              return false;
            }
          }

          // 비밀번호 유효성 검사
          if (!EmptyCheck(this.password, "비밀번호를")) {
            return false;
          }

          var pageIdx = this.pageIdx;

          /* var params = {
                      password: this.password,
                      id: this.email + this.item_email.replace('E-mail@', ''),
                      pageIdx: pageIdx
                  } 웹취약점 */

          var params = new URLSearchParams();

          params.append("password", this.password);
          //params.append('id', this.email + this.item_email.replace('E-mail@', ''))
          params.append("pageIdx", pageIdx);

          // 로그인시 관리자에서 도메인을 입력한 경우 파라마티값 추가
          if (this.useUrl) {
            //params['id'] = this.email + this.item_email.replace('E-mail', '')
            params.append("id", this.email + this.item_email.replace("E-mail", ""));
          } else {
            params.append("id", this.email + this.item_email.replace("E-mail@", ""));
          }

          // 신청내역 확인을 위한 로그인 api
          /* this.axios.get(this.axios.root + this.axios.port + `/login/history/${pageIdx}`, {
                      params: params
                  }).then(res => { 웹취약점 */

          this.axios.post(this.axios.root + this.axios.port + "/login/history/page", params).then((res) => {
            // console.log('res', res)
            if (res.data.err === 0) {
              this.isValidAuth = true;
              localStorage.setItem("accessToken", res.data.accessToken);
              localStorage.setItem("userId", this.email);
              this.axios.defaults.headers.common["accessToken"] = res.data.accessToken;
              sessionStorage.setItem("logo", this.logo);
              sessionStorage.setItem("mainTitle", this.title);
              sessionStorage.setItem("qaAdminInfo", this.qaAdminInfo);
              sessionStorage.setItem("cancle_YN", res.data.cancleYN);

              // 신청내역확인하는 경우에도 결제 페이지가 있는지 없는지 필요하므로 api호출
              // 클래스선택o 결제페이지x 인 경우에 금액이 안나오도록 하기 위함
              this.axios.get(this.axios.root + this.axios.port + `/sugang/page/${pageIdx}`).then((res) => {
                // console.log(res);
                if (res.data.err === 0) {
                  var pOrder = [];
                  for (var i = 1; i <= 8; i++) {
                    for (var item of res.data.menu) {
                      if (item.order === i.toString()) {
                        if (item.status === "Y") {
                          if (item.name === "agree") {
                            pOrder.push("terms");
                          } else if (item.name === "guide") {
                            pOrder.push("info");
                          } else if (item.name === "choose") {
                            pOrder.push("select");
                          } else if (item.name === "info") {
                            pOrder.push("input");
                          } else if (item.name === "pay") {
                            pOrder.push("payment");
                          } else if (item.name === "complete") {
                            pOrder.push("complete");
                          } else if (item.name === "popup") {
                            // sessionStorage.setItem('selectPopup', true)
                          }
                        }
                      }
                    }
                  }

                  sessionStorage.setItem("pOrder", JSON.stringify(pOrder));
                  this.$router.push("/user/applyList");
                }
              });
            } else if (res.data.err === 140) {
              alert("수강신청 내역을 확인할 수 없는 ID 혹은 비밀번호입니다.");
              this.loginFailCount = res.data.loginFailCount;
              this.isValidAuth = false;
              return false;
            } else if (res.data.err === 666) {
              alert("5회 로그인 실패로 해당 계정은 잠겼습니다." + "\n" + "아래에 [비밀번호를 잊으셨나요? 비밀번호 찾기]를 이용해주세요");
              this.lock = "lock";
              this.loginFailCount = res.data.loginFailCount;
            } else {
              //this.loginFailCount = res.data.loginFailCount
              alert(res.data.result);
              this.isValidAuth = false;
              return false;
            }
          });
        }
      }
    },

    // 로그인시 수강신청 페이지 데이터 로드
    fetchProcessData() {
      var params = {
        pageIdx: this.pageIdx,
      };

      this.axios
        .get(this.axios.root + this.axios.port + `/user/select-program/${this.pageIdx}`, {
          params: params,
        })
        .then((res) => {
          // console.log('res', res)
          if (res.data.err === 0) {
            var program_types = [];
            for (var item of res.data.programList) {
              program_types.push({
                program_type: item.program_type,
                program_name: item.program_name,
                programIdx: item.idx,
              });
            }

            // 해당 수강신청의 프로그램 타입 종류 저장
            sessionStorage.setItem("program_types", JSON.stringify(program_types));
            // alert('인증 완료')
            this.$router.push("/user/reg/init");
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          // console.log(err)
          alert(err);
        });
    },

    // 모달 열기
    openModal(type) {
      if (type === "findPW") {
        this.isFindPWModalOpened = true;
      } else if (type === "qna") {
        this.isQnaModalOpened = true;
      } else {
        this.isLockModalOpened = true;
      }
    },

    // 모달 닫기
    closeModal() {
      if (this.isFindPWModalOpened) {
        this.isFindPWModalOpened = false;
      } else if (this.isQnaModalOpened) {
        this.isQnaModalOpened = false;
      } else {
        this.isLockModalOpened = false;
      }
    },
  },
};
</script>
<style>
strong {
  font-weight: bold;
}
.loader {
  position: relative;
  left: 48%;
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 27px;
  height: 27px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.submit {
  width: 100%;
  height: 50px;
  background: #666666;
  color: #fff;
  border: none;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
}
.contact {
  min-height: 66px;
}
.mt-10 {
  margin-top: 10px;
}
</style>
